import { PropsWithChildren } from "react";

interface SchedulingMethodProps extends PropsWithChildren {
  icon: JSX.Element;
}

export const SchedulingMethod = ({ icon, children }: SchedulingMethodProps) => {
  return (
    <div className="flex gap-2">
      {icon}
      <div>{children}</div>
    </div>
  );
};
